/* Article – Sommaire automatique construit depuis les titres H2/H3 du contenu */
(function () {
  var MIN_HEADINGS = 2;

  function slugify(text) {
    return text
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '') // retire les accents
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildToc(section) {
    var nav = section.querySelector('[data-article-toc]');
    var content = section.querySelector('[data-toc-content]');
    if (!nav || !content) return;

    var list = nav.querySelector('.article-toc__list');
    if (!list) return;

    var selector = nav.getAttribute('data-toc-depth') === 'h2_h3' ? 'h2, h3' : 'h2';
    var headings = content.querySelectorAll(selector);
    if (headings.length < MIN_HEADINGS) return;

    var used = {};
    var entries = [];

    headings.forEach(function (heading, index) {
      var label = (heading.textContent || '').trim();
      if (!label) return;

      var id = heading.id;
      if (!id) {
        var base = slugify(label) || 'sommaire-' + (index + 1);
        id = base;
        var suffix = 2;
        while (used[id] || document.getElementById(id)) {
          id = base + '-' + suffix;
          suffix += 1;
        }
        heading.id = id;
      }

      heading.setAttribute('tabindex', '-1'); // focusable par script, hors ordre de tabulation
      used[id] = true;
      entries.push({ id: id, label: label, level: heading.tagName.toLowerCase() });
    });

    if (entries.length < MIN_HEADINGS) return;

    var fragment = document.createDocumentFragment();
    entries.forEach(function (entry) {
      var item = document.createElement('li');
      item.className = 'article-toc__item';
      if (entry.level === 'h3') item.className += ' article-toc__item--sub';

      var link = document.createElement('a');
      link.className = 'article-toc__link';
      link.href = '#' + entry.id;
      link.textContent = entry.label;

      item.appendChild(link);
      fragment.appendChild(item);
    });

    list.appendChild(fragment);
    nav.hidden = false;

    // A11y : au clic, place le focus sur le titre ciblé (preventScroll : l'ancre native gère le défilement + l'offset)
    list.addEventListener('click', function (event) {
      var link = event.target.closest('.article-toc__link');
      if (!link) return;
      var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (target) target.focus({ preventScroll: true });
    });
  }

  function init() {
    document.querySelectorAll('.shopify-section--main-article').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
